
namespace SP {
    export let ActiveNotifications: DismissInfo[] = [];

    export function DismissAll() {
        for (var i = ActiveNotifications.length - 1; i >= 0; i--) {
            ActiveNotifications[i].dismiss.click();
        }
    }

    function keyEvent(e: KeyboardEvent) {
        if (e.which == 13 || e.which == 32) {
            if (ActiveNotifications.length) {
                ActiveNotifications[ActiveNotifications.length - 1].dismiss_fn();
            }
        }
    }
    let bound = false;

    function bindEvents() {
        if (!bound) {
            bound = true;
            document.addEventListener("keydown", keyEvent);
        }
    }

    function unbindEvents() {
        if (bound && ActiveNotifications.length == 0) {
            bound = false;
            document.removeEventListener("keydown", keyEvent);
        }

    }

    export class DismissInfo {
        container = document.createElement("div");
        inner = document.createElement("div");
        header = document.createElement("div");
        content = document.createElement("div");
        dismiss = document.createElement("div");

        constructor(headline: string, content: string) {
            this.container.classList.add("info-controller");
            this.container.addEventListener("click", () => { this.dismiss_fn(); });
            this.inner.classList.add("inner");
            this.inner.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); return false; });
            this.header.classList.add("header");
            this.content.classList.add("content");
            this.dismiss.classList.add("dismiss");

            this.container.appendChild(this.inner);
            this.inner.appendChild(this.header);
            this.inner.appendChild(this.content);
            this.inner.appendChild(this.dismiss);
            this.dismiss.innerHTML = SP.Localize("word_dismiss");
            document.body.appendChild(this.container);



            ActiveNotifications.push(this);
            bindEvents();
            this.dismiss.addEventListener("click", () => {
                this.dismiss_fn();
            });

            this.header.innerHTML = headline;
            this.content.innerHTML = content;
        }

        dismiss_fn() {
            ActiveNotifications.splice(ActiveNotifications.indexOf(this), 1);
            this.container.remove();
            unbindEvents();
        }
    }

}